// VFX: Callout Box SVG Draw
// Category: card-animations · Tags: ui, callout, box, draw, svg
// Box de callout com borda que se desenha via SVG stroke animation. Depois texto revela.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface CalloutBoxDrawProps {
  title?: string;
  body?: string;
  accentColor?: string;
  dark?: boolean;
  delay?: number;
}

export default function CalloutBoxDraw({
  title = "ATENÇÃO",
  body = "Isso está custando você dinheiro todo mês.",
  accentColor = "#f97316",
  dark = true,
  delay = 0,
}: CalloutBoxDrawProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const boxP = spring({ frame: frame - delay, fps, config: { damping: 200, stiffness: 120 } });
  const drawP = interpolate(frame - delay, [0, 18], [0, 1], clamp);
  const titleP = spring({ frame: frame - delay - 16, fps, config: { damping: 160, stiffness: 180 } });
  const bodyP = spring({ frame: frame - delay - 24, fps, config: { damping: 160, stiffness: 180 } });
  const bg = dark ? "#0a0e1a" : "#ffffff";
  const textColor = dark ? "#f8fafc" : "#1a1a2e";
  const W = 580, H = 140, r = 12;
  const perim = 2 * (W + H);
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: bg }}>
      <div style={{ width: W, height: H, position: "relative", opacity: boxP }}>
        <svg style={{ position: "absolute", inset: 0 }} width={W} height={H} viewBox={`0 0 ${W} ${H}`}>
          <rect x="1" y="1" width={W - 2} height={H - 2} rx={r} ry={r}
            fill="none" stroke={accentColor} strokeWidth={1.5}
            strokeDasharray={perim}
            strokeDashoffset={perim * (1 - drawP)}
            strokeLinecap="round"
          />
        </svg>
        <div style={{ position: "absolute", inset: 0, borderRadius: r, background: `${accentColor}14`, padding: "20px 24px", display: "flex", flexDirection: "column", justifyContent: "center", gap: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: accentColor, fontFamily: "system-ui", opacity: titleP, transform: `translateX(${interpolate(titleP, [0, 1], [-10, 0], clamp)}px)` }}>{title}</div>
          <div style={{ fontSize: 17, fontWeight: 400, color: textColor, fontFamily: "system-ui", lineHeight: 1.5, opacity: bodyP, transform: `translateX(${interpolate(bodyP, [0, 1], [-8, 0], clamp)}px)` }}>{body}</div>
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
